/* eslint-disable */
import React from 'react';
import Lottie from 'react-lottie';
import * as animationData from '../../assets/animation/global_loader.json';

interface ComponentState {
  isStopped?: boolean;
  isPaused?: boolean;
}

class Loader extends React.Component<React.CSSProperties, ComponentState> {
  constructor(props: React.CSSProperties) {
    super(props);
    this.state = { isStopped: false, isPaused: false };
  }

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    return (
      <Lottie
        options={defaultOptions}
        height={this.props?.height ?? 35}
        width={this.props?.width ?? 25}
        isStopped={this.state.isStopped}
        isPaused={this.state.isPaused}
        style={{
          cursor: 'inherit',
        }}
      />
    );
  }
}

export { Loader };
